import type { ModalProps } from 'antd'
import { Modal as AntdModal } from 'antd'

export default function Modal({ children, ...props }: ModalProps) {
  return (
    <AntdModal open {...props}>
      {children}
    </AntdModal>
  )
}
